module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANhJREFUSEu11E0OgjAQhuEZFxxJvZaa6EJDYvyJbuBa6KEcA7GNhbbzFQrr6fuQlsKU8Cx3sl98qGhqvqLLGB1s4yz0/M2Xr4ovyFoIWG/lIESPXhBCVCAQN5aKRAElDiFBAIyriBdIjEeRATAyHkQcYGLci1ggU3yAdEDmuIPwTHGL8GojJTGdkWufOsNC926L5kDaeFPz0R5yTkSIbu+KT+3LO59pDuQ/PgCmblc/7gXGIr54EEhFQvEogCKxuApoiBaHgBCCxGGgj6DxJMAgwlSYS4T8Or7hUYprjHilewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/ic_listPoint.png
// module id = 0Q86
// module chunks = 1